import eventManger, { EventType } from '../utilities/EventManager';
import _ from 'lodash';
import moment from 'moment';
moment.locale('ja');

import { DATE_TIME_FORMAT } from '../utilities/constants';

export default class CalenderComponent {
  constructor(component) {
    this.component = component;
    this.rid = `cal-${this.getRandomId()}`;
    this.component.classList.add(this.rid);
    this.callbck = [];
    this.today = moment();
    this.selectday = moment();

    this.showDropdown = this.showDropdown.bind(this);
  }

  init() {
    this.generateBase();
    this.updateCalender();

    //値を持っていたらtodayに設定
    if (this.component.querySelector('.sys-name').value) {
      //console.log("calender init = " , this.component.querySelector(".sys-name").value);
      this.today = moment(
        new Date(this.component.querySelector('.sys-name').value).toISOString()
      );
    }
  }

  setCallback(func) {
    //console.log("calender setcallback" , func);
    this.callback = func;
  }

  addSelectButtonEvent() {
    this.component
      .querySelector('.dropdown-calender')
      .removeEventListener('click', this.stopProp);
    this.component
      .querySelector('.dropdown-calender')
      .addEventListener('click', this.stopProp);

    //ドロップダウン表示
    this.component
      .querySelector('.sys-dropdown-trigger')
      .removeEventListener('click', this.showDropdown);
    this.component
      .querySelector('.sys-dropdown-trigger')
      .addEventListener('click', this.showDropdown);
  }

  stopProp(e) {
    e.stopPropagation();
  }

  showDropdown(e) {
    e.preventDefault();
    e.stopPropagation();
    //値を持っていたらtodayに設定
    if (this.component.querySelector('.sys-name').value) {
      this.today = moment(this.component.querySelector('.sys-name').value);
    }
    const triggerElement = this.component.querySelector(
      '.sys-dropdown-trigger'
    );
    const componentRect = this.component.getBoundingClientRect();
    const triggerRect = triggerElement.getBoundingClientRect();
    this.component.querySelector('.dropdown-calender').classList.add('show');
    this.component.querySelector('.dropdown').style.position = 'absolute';
    const calenderRect = this.component
      .querySelector('.dropdown-calender__calender')
      .getBoundingClientRect();

    // カレンダーの表示位置を決定する
    let bottomMargin =
      document.documentElement.clientHeight - componentRect.bottom;
    const rightMarginFromLeft =
      document.documentElement.clientWidth - componentRect.left;
    let forceShowBottom = triggerElement.classList.contains(
      'sys-dropdown-trigger--force-down'
    );

    if (
      triggerElement.classList.contains('sys-dropdown-trigger--inner-dialog')
    ) {
      const dialogBody = this.component.closest('.dialog-md__body');
      if (dialogBody) {
        const dialogBodyRect = dialogBody.getBoundingClientRect();
        bottomMargin =
          dialogBody.scrollHeight -
          (dialogBody.clientHeight + dialogBody.scrollTop) +
          (dialogBodyRect.bottom - componentRect.bottom);
        const topMargin =
          dialogBody.scrollHeight - bottomMargin - componentRect.height;
        if (topMargin < bottomMargin) {
          forceShowBottom = true;
        }
      }
    }
    if (
      bottomMargin < calenderRect.height &&
      rightMarginFromLeft < calenderRect.width
    ) {
      // カレンダー右部と下部にスペースが無い場合、入力フォームの左下部揃えで左側に表示
      this.component.querySelector(
        '.dropdown'
      ).style.top = `${0 - calenderRect.height}px`;
      this.component.querySelector(
        '.dropdown'
      ).style.left = `${triggerRect.width - calenderRect.width}px`;
    } else if (
      bottomMargin < calenderRect.height &&
      rightMarginFromLeft > calenderRect.width
    ) {
      // カレンダー下部にスペースが無い場合、入力フォームの右下部揃えで右側に表示
      this.component.querySelector(
        '.dropdown'
      ).style.top = `${0 - calenderRect.height}px`;
      this.component.querySelector('.dropdown').style.left = 0;
    } else if (
      bottomMargin > calenderRect.height &&
      rightMarginFromLeft < calenderRect.width
    ) {
      // カレンダー右部にスペースが無い場合、入力フォームの右下部揃えで下側に表示
      this.component.querySelector('.dropdown').style.top = `${triggerRect.top +
        triggerRect.height -
        componentRect.top}px`;
      this.component.querySelector(
        '.dropdown'
      ).style.left = `${triggerRect.width - calenderRect.width}px`;
    } else if (
      bottomMargin > calenderRect.height &&
      rightMarginFromLeft > calenderRect.width
    ) {
      // カレンダー右部と下部にスペースが有る場合、入力フォームの左下部揃えで下側に表示
      this.component.querySelector('.dropdown').style.top = `${triggerRect.top +
        triggerRect.height -
        componentRect.top}px`;
      this.component.querySelector(
        '.dropdown'
      ).style.left = 0;
    }
    if (forceShowBottom) {
      this.component.querySelector('.dropdown').style.top = `${triggerRect.top +
        triggerRect.height -
        componentRect.top}px`;
    }

    this.updateCalender();
  }

  /**
   * カレンダー操作
   */
  calenderNavi() {
    return {
      selectDay: e => {
        const parent = e.target.parentNode;
        parent.classList.add('select');

        let d = 0;
        _.each(parent.classList, classname => {
          if (classname.match(/^sys-enable-day-(.*)/)) {
            d = classname.match(/^sys-enable-day-(.*)/)[1];
          }
        });
        this.today.date(d);
      },
      clearDay: () => {
        const days = this.component.querySelectorAll('.calender-day');
        _.each(days, day => {
          day.classList.remove('select');
        });
      },
      prevMonth: () => {
        this.today = this.today.clone().add(1, 'month');
      },
      nextMonth: () => {
        this.today = this.today.clone().add(-1, 'month');
      },
      prevDay: () => {
        this.prepareTodayData();
        this.today = this.today.clone().add(-1, 'day');
      },
      nextDay: () => {
        this.prepareTodayData();
        this.today = this.today.clone().add(1, 'day');
      },
    };
  }

  /**
   * カレンダーの初期化後にデータがセットされた際に日付のズレが発生するのを防ぐ
   */
  prepareTodayData() {
    if (this.component.querySelector('.sys-name').value) {
      const inputDate = moment(
        new Date(this.component.querySelector('.sys-name').value).toISOString()
      );

      if (
        !moment(
          new Date(
            inputDate.format(DATE_TIME_FORMAT.slashDateFormat)
          ).toISOString()
        ).isSame(
          new Date(
            this.today.format(DATE_TIME_FORMAT.slashDateFormat)
          ).toISOString(),
          'day'
        )
      ) {
        this.today = inputDate;
      }
    }
  }

  /**
   * カレンダーのイベントをアタッチする
   */
  addCalenderEvent() {
    const days = this.component.querySelectorAll('.calender-day');
    _.each(days, day => {
      day.querySelector('.sys-cal-day').addEventListener('change', e => {
        this.calenderNavi().clearDay();
        this.calenderNavi().selectDay(e);
      });
    });
  }

  updateCalender() {
    this.generateDay();
    this.addSelectButtonEvent();
    this.addCalenderEvent();

    this.component.querySelector(
      '.sys-calender-title'
    ).innerHTML = `${this.today.format('YYYY')} / ${this.today.format('MM')}`;

    //todayを選択
    //console.log("updatecalender = ",this.component.querySelector(".sys-name") , this.today.format("YYYY/MM/DD"));
    if (
      this.component.querySelector(`.sys-enable-day-${this.today.format('D')}`)
    ) {
      this.component
        .querySelector(`.sys-enable-day-${this.today.format('D')}`)
        .classList.add('select');
      this.component.querySelector(
        `.sys-enable-day-${this.today.format('D')} .sys-cal-day`
      ).checked = true;
    }
  }

  generateBase() {
    this.component.style.display = 'inline-block';
    this.component.querySelector('.dropdown-calender').style.position =
      'relative';

    //カレンダー枠作成
    this.component
      .querySelector('.dropdown-calender__calender')
      .appendChild(this.getBase());

    //翌月
    this.component
      .querySelector('.sys-next-month')
      .addEventListener('click', e => {
        e.preventDefault();
        this.calenderNavi().prevMonth();
        this.updateCalender();
      });

    //先月
    this.component
      .querySelector('.sys-prev-month')
      .addEventListener('click', e => {
        e.preventDefault();
        this.calenderNavi().nextMonth();
        this.updateCalender();
      });

    //翌日
    this.component
      .querySelector('.sys-calender-day-up')
      .addEventListener('click', e => {
        e.preventDefault();
        this.calenderNavi().prevDay();
        this.submit();
      });

    //前日
    this.component
      .querySelector('.sys-calender-day-down')
      .addEventListener('click', e => {
        e.preventDefault();
        this.calenderNavi().nextDay();
        this.submit();
      });

    //選択
    this.component.querySelector('.sys-submit').addEventListener('click', e => {
      e.preventDefault();
      this.submit();
    });
  }

  submit() {
    if (this.callback) {
      const input = this.component.querySelector('.sys-name');
      this.selectday = this.today.clone().format('YYYY/MM/DD');
      input.value = this.selectday;
      this.callback(this.component, input.name, this.selectday);
      eventManger.trigger(EventType.DROPDOWN_MENU);
    }
  }

  generateDay() {
    this.component.querySelector('.sys-calender-body').innerHTML = '';
    this.calenderbody = this.component.querySelector('.sys-calender-body');

    let _today = this.today.clone();
    let days_num = _today.daysInMonth();
    const first = _today.date(1).format('D');
    const last = _today.date(days_num).format('D');
    //console.log("generate Day = " , _today ,first , last );

    var counter = 1;
    for (var i = 1; i <= 6; i++) {
      var tr = document.createElement('tr');
      tr.classList.add('calender__week');
      tr.classList.add(`sys-row${i}`);
      this.calenderbody.appendChild(tr);

      for (var d = 0; d < 7; d++) {
        if (
          _today.date(counter).format('d') == d && //曜日
          counter >= first &&
          counter <= last
        ) {
          const line = this.getDay({
            classname: `sys-row-${i} sys-col-${d}`,
            day: counter,
            row: i,
            col: d,
          });
          tr.appendChild(line);
          counter++;
        } else {
          //無効
          const line = this.getDay({
            classname: '',
            day: '-',
            row: 9,
            col: 9,
          });
          tr.appendChild(line);
        }
      }
    }
  }

  getDay(param) {
    let element = document.createElement('td');
    element.classList.add('calender__day');
    element.insertAdjacentHTML(
      'beforeend',
      `<label id="${this.rid}-${param.day}" for="${this.rid}-calender-${
        param.day
      }" class="calender-day sys-enable-col-${param.col} sys-enable-day-${
        param.day
      }">
          <input id="${this.rid}-calender-${
        param.day
      }" type="checkbox" class="sys-cal-day ${param.classname}" />
          <div class="calender-day__number">${param.day}</div>
        </label>`
    );
    return element;
  }

  getBase() {
    let element = document.createElement('div');
    element.insertAdjacentHTML(
      'beforeend',
      `<div class="${this.rid} popup-calender">
        <div class="popup-calender__header"></div>
        <div class="popup-calender__calender">
          <!-- カレンダー -->
          <div class="calender-header calender-header--popup-calender">
              <div class="calender-header__prev-month">
                <button class="btn-icon sys-prev-month">
                  <i class="i-arrow-left i-2x"></i>
                </button>
              </div>
              <div class="calender-header__title sys-calender-title"></div>
              <div class="calender-header__next-month">
                <button class="btn-icon sys-next-month">
                  <i class="i-arrow-right i-2x"></i>
                </button>
              </div>
          </div>
          <table class="calender calender--popup-calender">
            <thead>
              <tr class="calender__label">
                <th class="calender__day">
                  <label for="sys-select-col-0" class="calender-label">
                    <div class="calender-label__day">日</div>
                  </label>
                </th>
                <th class="calender__day">
                  <label for="sys-select-col-1" class="calender-label">
                    <div class="calender-label__day">月</div>
                  </label>
                </th>
                <th class="calender__day">
                    <label for="sys-select-col-2" class="calender-label">
                      <div class="calender-label__day">火</div>
                    </label>
                </th>
                <th class="calender__day">
                  <label for="sys-select-col-3" class="calender-label">
                    <div class="calender-label__day">水</div>
                  </label>
                </th>
                <th class="calender__day">
                  <label for="sys-select-col-4" class="calender-label">
                    <div class="calender-label__day">木</div>
                  </label>
                </th>
                <th class="calender__day">
                  <label for="sys-select-col-5" class="calender-label">
                    <div class="calender-label__day">金</div>
                  </label>
                </th>
                <th class="calender__day">
                  <label for="sys-select-col-6" class="calender-label">
                    <div class="calender-label__day">土</div>
                  </label>
                </th>
              </tr>
            </thead>
            <tbody class="sys-calender-body">
            </tbody>
          </table>
        </div>
        <div class="popup-calender__footer">
          <button class="btn--sm--stay sys-submit">選択</button>
        </div>
      </div>`
    );
    return element;
  }

  getRandomId() {
    var str = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var len = 10;
    var result = '';
    for (var i = 0; i < len; i++) {
      result += str.charAt(Math.floor(Math.random() * str.length));
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/components/CalenderComponent.js